export default __webpack_public_path__ + "static/media/Chairman.f4312eb7.jpg";